import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import trans from 'translate';
import { connect, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import {
  createHPoolGoNextAction,
  createHPoolGoBackAction,
  createHPoolSkipAction,
} from '../../../../redux/actions/createHPoolActions';

import './CreateHPoolControls.scss';

const CreateHPoolControls = ({
  buttonType,
  createHPoolGoNextAction,
  noBack,
  createHPoolGoBackAction,
  lastStep,
  createHPoolSkipAction,
  disabled,
  submitting,
  form,
  loadingText,
  loading,
}) => {
  const location = useLocation();
  const history = useHistory();

  const path = useMemo(() => /[^/]*$/.exec(location.pathname)[0], [location.pathname]);
  const { is_vpool: isVpool } = useSelector((state) => state.createHPool.hpool);

  const createHPoolGoNextActionCallback = useCallback(
    () => createHPoolGoNextAction(path, history),
    [path, history, createHPoolGoNextAction],
  );
  const createHPoolGoBackActionCallback = useCallback(
    () => createHPoolGoBackAction(path, history),
    [path, history, createHPoolGoBackAction],
  );
  const createHPoolSkipActionCallback = useCallback(
    () => createHPoolSkipAction(history),
    [history, createHPoolSkipAction],
  );

  const rightButtonProps = useMemo(() => {
    const _rightButtonProps = {};

    if (!lastStep) _rightButtonProps.onClick = createHPoolGoNextActionCallback;
    else _rightButtonProps.form = form;

    return _rightButtonProps;
  }, [form, createHPoolGoNextActionCallback, lastStep]);

  const btnText = isVpool ? 'vpool.initiate_vpool' : 'pools.initiate_hpool';
  const showSkipBtn = lastStep && !isVpool;

  return (
    <div className="create-hpool-controls-wrapper">
      {!noBack && (
        <button type="button" className="button back" onClick={createHPoolGoBackActionCallback}>
          {trans('common.back')}
        </button>
      )}

      <div className="right-button-wrapper">
        <button
          type={buttonType} // eslint-disable-line
          className="button green"
          disabled={disabled || loading}
          {...rightButtonProps}
        >
          {lastStep ? (
            submitting ? (
              trans('pools.initiating_hpool')
            ) : (
              trans(btnText)
            )
          ) : (
            <>{trans(loading ? loadingText : 'common.next')}</>
          )}
        </button>

        {showSkipBtn && (
          <div className="skip" onClick={createHPoolSkipActionCallback}>
            {trans('pools.skip_for_now')}
          </div>
        )}
      </div>
    </div>
  );
};

CreateHPoolControls.defaultProps = {
  buttonType: 'button',
  noBack: false,
  lastStep: false,
  disabled: false,
  submitting: false,
  form: '',
  loadingText: '',
  loading: false,
};

CreateHPoolControls.propTypes = {
  createHPoolGoNextAction: PropTypes.func.isRequired,
  createHPoolGoBackAction: PropTypes.func.isRequired,
  createHPoolSkipAction: PropTypes.func.isRequired,
  buttonType: PropTypes.string,
  noBack: PropTypes.bool,
  lastStep: PropTypes.bool,
  disabled: PropTypes.bool,
  submitting: PropTypes.bool,
  form: PropTypes.string,
  loadingText: PropTypes.string,
  loading: PropTypes.bool,
};

const mapDispatchToProps = {
  createHPoolGoBackAction,
  createHPoolGoNextAction,
  createHPoolSkipAction,
};

export default connect(null, mapDispatchToProps)(CreateHPoolControls);
